/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CRSFSecReviewLocale = {
    EnUs: 'en-US',
    EnGb: 'en-GB',
    EnCa: 'en-CA',
    EnAu: 'en-AU',
    DeDe: 'de-DE',
    FrCa: 'fr-CA'
} as const;
export type CRSFSecReviewLocale = typeof CRSFSecReviewLocale[keyof typeof CRSFSecReviewLocale];


export function CRSFSecReviewLocaleFromJSON(json: any): CRSFSecReviewLocale {
    return CRSFSecReviewLocaleFromJSONTyped(json, false);
}

export function CRSFSecReviewLocaleFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewLocale {
    return json as CRSFSecReviewLocale;
}

export function CRSFSecReviewLocaleToJSON(value?: CRSFSecReviewLocale | null): any {
    return value as any;
}

